import { createVuetify } from 'vuetify';
import { themeConfig } from '@/theme/colors';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

export default createVuetify({
  theme: themeConfig,
});
